<template>
    <div id="fs5-cards-status-payments">
        <div class="get-paid-cardStatus">
            <div v-for="(card, i) in view" :key="i">
                <div class="get-paid-cardItem">
                    <div class="get-paid-topPaid">
                        <div class="get-paid-cardImage" :style="'backgroundColor:'+card.style+';'">
                            <img class="get-paid-cardIcon" :src="'/internacional/public/office5/img/franchise_dashboard/svg/'+card.icon" :alt="card.title">
                        </div>
                        <p class="get-paid-cardTitle" v-html="card.title"></p>
                    </div>
                    <table class="get-paid-tablePaid">
                        <tr v-for="(item, i) in card.items" :key="i">
                            <div :class="[item.type != 'USD' ? 'get-paid-box-td' : 'get-paid-box-td-usd']" v-if="item.show || item.value > 0">
                                <td class="get-paid-tdType" v-html="item.type"></td>
                                <td class="get-paid-tdValue" v-html="item.symbol + ' ' + item.value"></td>
                            </div>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'fs5-cards-status-payments',
        props: ['view'],
    }
</script>

<style scoped lang="scss">
    @import '../../../../../../scss/extras/_variables'; // see fonts and colors with prefix $fs5
    #fs5-cards-status-payments {
        font: inherit;
    }
    .get-paid-cardStatus {
        display: flex;
        flex-direction: row;
        column-gap: 2.8%;
        align-items: center;
        justify-content: space-evenly;
        flex-wrap: wrap;
    }
    .get-paid-tablePaid {
        width: 100%;
        .get-paid-box-td{
            border-top: 1px solid $fs5-color1;
        }
        .get-paid-box-td,
        .get-paid-box-td-usd{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
    }
    .get-paid-topPaid {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: left;
        margin-bottom: 1em;
    }
    .get-paid-cardIcon {
        width: 2.2em;
    }
    .get-paid-cardTitle {
        font-size: 1em;
        line-height: 1.5em;
        color: $fs5-color11;
        font-weight: bold;
        margin-top: 0.62em;
        margin-left: 0.4em;
    }
    .get-paid-cardImage {
        height: 3.1em;
        width: 3.1em;
        border-radius: 7px;
        display: flex;
        justify-content: center;
    }
    .get-paid-tdType {
        font-weight: 800;
        font-size: 1em;
        color: #707070;
    }
    .get-paid-tdValue {
        padding: 1em;
        text-align: right;
        color: #05CD99;
        font-weight: bold;
    }
    .get-paid-cardItem {
        background-color: #fff;
        padding: 1em;
        border: 1px solid #C9E4FF;
        border-radius: 8px;
        width: 17em;
        margin-bottom: 1em;
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/get_paid/user/card_status_payments/index.vue